import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {ProductoMontoPlazoInversion} from '../_models/producto-monto-plazo-inversion';

@Injectable({
  providedIn: 'root'
})
export class ProductoMontoPlazoInversionService {
  private rutServicio: string = AppSettings.rutServiciosAPL + "/api/productosPlazoMontoInversion";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService,
  ) {}

  getAll(): Observable<ProductoMontoPlazoInversion[]> {
    return this.httpClient.get<ProductoMontoPlazoInversion[]>(this.rutServicio);
  }

  getEnabled(): Observable<ProductoMontoPlazoInversion[]> {
    return this.httpClient.get<ProductoMontoPlazoInversion[]>(`${this.rutServicio}/enabled}`);
  }

  getById(id: string): Observable<ProductoMontoPlazoInversion[]> {
    return this.httpClient.get<ProductoMontoPlazoInversion[]>(`${this.rutServicio}/${id}`);
  }

  getByIdProducto(id: string): Observable<ProductoMontoPlazoInversion[]> {
    return this.httpClient.get<ProductoMontoPlazoInversion[]>(`${this.rutServicio}/producto/${id}`);
  }

  create(registro: ProductoMontoPlazoInversion): Observable<ProductoMontoPlazoInversion> {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductoMontoPlazoInversion>(this.rutServicio, registro);
  }

  update(registro: ProductoMontoPlazoInversion): Observable<ProductoMontoPlazoInversion> {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put<ProductoMontoPlazoInversion>(this.rutServicio, registro);
  }

  bulk(registros: ProductoMontoPlazoInversion[]): Observable<ProductoMontoPlazoInversion[]> {
    registros.forEach((e: ProductoMontoPlazoInversion) => e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoMontoPlazoInversion[]>(`${this.rutServicio}/bulk`, registros);
  }
}
